'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.trace = exports.log = exports.info = exports.error = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildDevLogger = function buildDevLogger(methodName) {
  return function () {
    if (_enviro2.default.isQa() || !_enviro2.default.deployed()) {
      var _console;

      (_console = console)[methodName].apply(_console, arguments);
    }
  };
};

var error = exports.error = buildDevLogger('error');
var info = exports.info = buildDevLogger('info');
var log = exports.log = buildDevLogger('log');
var trace = exports.trace = buildDevLogger('trace');
var warn = exports.warn = buildDevLogger('warn');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-infrastructure/static-1.19/js/logger/devLogger.js
// module id = 401
// module chunks = 2 3